<template>
    <div 
        class="wg-flex__column" 
        :class="{
            ['wg-flex__column-spacing-' + realSpacing]: realSpacing,
            ['wg-flex__column-spacing']: realSpacing,
            'wg-flex__shrink': +realStyle.flexShrink === 0,
            ['wg-flex__align-' + realStyle.alignItems]: realStyle.alignItems,
             ['wg-shadow__' + finalBoxShadow]: finalBoxShadow,
            ['wg-' + layoutPosition]: layoutPosition,
            ['wg-bg-color__' + finalBackgroundColor]: finalBackgroundColor,
            ['wg-border__' + borderLine]: borderLine,
            ['wg-border__box']: borderBox,
            ['wg-border__radius-' + originBorderRadius]: originBorderRadius,
            [className]: className,
        }"
        :style="Object.assign(extraStyle, {
            'justify-content': realStyle.justifyContent,
            margin: finalMargin,
            padding: finalPadding,
            borderRadius: borderRadius,
            backgroundColor: customBackgroundColor,
            width: realWidth,
            height: realHeight
        })"
        >
        <slot></slot>
    </div>
</template>
<script>
import Mixin from '../mixin.js';

export default {
    name: 'Column',
    mixins: [Mixin],
    data () {
        return {
            defaultStyle: {
                flexShrink: 1,
                justifyContent: '',
                alignItems: '',
                spacing: 0,
                width: '',
                height: ''
            }
        }
    },
    props: {
        styleObject: {
            type: Object,
            default () {
                return {
                }
            }
        }
    },
    computed: {
        realStyle () {
            return Object.assign(this.defaultStyle, (this.styleObject || {}))
        },
        realSpacing () {
            return this.realStyle.spacing * (this.baseOneSpace || 8)
        },
        realWidth () {
            let val = this.realStyle.width
            if(val) {
                if(('' + val).indexOf('%') > -1 ) {
                    return val
                }else {
                    return (val + 'px')
                }
            }else {
                return ''
            }
        },
        realHeight () {
            let val = this.realStyle.height
            if(val) {
                if(('' + val).indexOf('%') > -1 ) {
                    return val
                }else {
                    return (val + 'px')
                }
            }else {
                return ''
            }
        }
    }
}
</script>
<style lang="less">
</style>